import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

import { RegistrationErrorType } from '../../../../core/enums';
import { DialogComponent } from '../../../../core/models/dialog.data';
import { environment } from '../../../../../environment/environment';

@Component({
  selector: 'dbx-registration-error-dialog',
  templateUrl: './registration-error-dialog.component.html',
  styleUrl: './registration-error-dialog.component.scss',
  imports: [TranslatePipe, MatButton, MatDialogTitle, MatDialogContent, MatDialogActions],
  standalone: true,
})
export class RegistrationErrorDialogComponent extends DialogComponent<
  RegistrationErrorDialogComponent,
  {
    errorType: RegistrationErrorType;
  },
  boolean
> {
  private readonly dialogData = inject<{ errorType: RegistrationErrorType }>(MAT_DIALOG_DATA);

  translatePrefix =
    this.dialogData.errorType === RegistrationErrorType.InvalidInformation
      ? 'registration.errorDialog.invalidInformation'
      : 'registration.errorDialog.boxOffline';

  action(): void {
    this.close(true);
  }

  protected readonly environment = environment;
}
